export const BASE_COLOR_PROGRESS = "#42b883";
export const INERTIA_VISIT_START = "start";
export const INERTIA_VISIT_STOP = "stop";

export const UangMakanHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 16,
    POS_COL_JML_USULAN: 17,
    POS_COL_KURANG_BAYAR: 18,
    POS_COL_BRUTO: 19,
    POS_COL_POT_USULAN: 20,
    POS_COL_TAB_PAJAK_PERSEN: 21,
    POS_COL_TAB_PAJAK_RUPIAH: 22,
    POS_COL_POT_PAJAK_PERSEN: 23,
    POS_COL_POT_PAJAK_RUPIAH: 24,
    POS_COL_ZAKAT_RUPIAH: 25,
    POS_COL_NETTO: 26,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 27,
};

export const IkwTutamHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 16,
    POS_COL_JML_USULAN: 17,
    POS_COL_KURANG_BAYAR: 18,
    POS_COL_BRUTO: 19,
    POS_COL_POT_USULAN: 20,
    POS_COL_TAB_PAJAK_PERSEN: 21,
    POS_COL_TAB_PAJAK_RUPIAH: 22,
    POS_COL_POT_PAJAK_PERSEN: 23,
    POS_COL_POT_PAJAK_RUPIAH: 24,
    POS_COL_ZAKAT_RUPIAH: 25,
    POS_COL_NETTO: 26,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 27,
};

export const IkwDosenHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 15,
    POS_COL_PERSEN_TERIMA: 19,
    POS_COL_JML_USULAN: 20,
    POS_COL_KURANG_BAYAR: 21,
    POS_COL_BRUTO: 22,
    POS_COL_POT_USULAN: 23,
    POS_COL_TAB_PAJAK_PERSEN: 24,
    POS_COL_TAB_PAJAK_RUPIAH: 25,
    POS_COL_POT_PAJAK_PERSEN: 26,
    POS_COL_POT_PAJAK_RUPIAH: 27,
    POS_COL_ZAKAT_RUPIAH: 28,
    POS_COL_NETTO: 29,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 30,
};

export const IkwTendikHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_NAMA_JABATAN: 12,
    POS_COL_TARIF: 14,
    POS_COL_PERSEN_TERIMA: 16,
    POS_COL_JML_USULAN: 17,
    POS_COL_KURANG_BAYAR: 18,
    POS_COL_BRUTO: 19,
    POS_COL_POT_USULAN: 20,
    POS_COL_TAB_PAJAK_PERSEN: 21,
    POS_COL_TAB_PAJAK_RUPIAH: 22,
    POS_COL_POT_PAJAK_PERSEN: 23,
    POS_COL_POT_PAJAK_RUPIAH: 24,
    POS_COL_ZAKAT_RUPIAH: 25,
    POS_COL_NETTO: 26,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 27,
};

export const HotIkwTendikJabatanBolehUbahConst = ["SEKRETARIS", "KEPALA BIRO"];

export const GajiHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 14,
    POS_COL_BPJS_1_PERSEN: 21,
    POS_COL_BPJS_1_RUPIAH: 22,
    POS_COL_BPJS_2_PERSEN: 23,
    POS_COL_BPJS_2_RUPIAH: 24,
    POS_COL_JML_USULAN: 26,
    POS_COL_KURANG_BAYAR: 27,
    POS_COL_BRUTO: 28,
    POS_COL_POT_USULAN: 29,
    POS_COL_TAB_PAJAK_PERSEN: 30,
    POS_COL_TAB_PAJAK_RUPIAH: 31,
    POS_COL_POT_PAJAK_PERSEN: 32,
    POS_COL_POT_PAJAK_RUPIAH: 33,
    POS_COL_ZAKAT_RUPIAH: 34,
    POS_COL_NETTO: 35,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 36,
};

export const ItpHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 14,
    POS_COL_PERSEN_TERIMA: 16,
    POS_COL_JML_USULAN: 17,
    POS_COL_TUNJ_KHUSUS: 18,
    POS_COL_KURANG_BAYAR: 19,
    POS_COL_BRUTO: 20,
    POS_COL_POT_USULAN: 21,
    POS_COL_TAB_PAJAK_PERSEN: 22,
    POS_COL_TAB_PAJAK_RUPIAH: 23,
    POS_COL_POT_PAJAK_PERSEN: 24,
    POS_COL_POT_PAJAK_RUPIAH: 25,
    POS_COL_ZAKAT_RUPIAH: 26,
    POS_COL_NETTO: 27,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 28,
};

export const IppHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 14,
    POS_COL_JML_USULAN: 15,
    POS_COL_KURANG_BAYAR: 16,
    POS_COL_BRUTO: 17,
    POS_COL_POT_USULAN: 18,
    POS_COL_TAB_PAJAK_PERSEN: 19,
    POS_COL_TAB_PAJAK_RUPIAH: 20,
    POS_COL_POT_PAJAK_PERSEN: 21,
    POS_COL_POT_PAJAK_RUPIAH: 22,
    POS_COL_ZAKAT_RUPIAH: 23,
    POS_COL_NETTO: 24,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 25,
};

export const IkkHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_TARIF: 14,
    POS_COL_JML_USULAN: 15,
    POS_COL_KURANG_BAYAR: 16,
    POS_COL_BRUTO: 17,
    POS_COL_POT_USULAN: 18,
    POS_COL_TAB_PAJAK_PERSEN: 19,
    POS_COL_TAB_PAJAK_RUPIAH: 20,
    POS_COL_POT_PAJAK_PERSEN: 21,
    POS_COL_POT_PAJAK_RUPIAH: 22,
    POS_COL_ZAKAT_RUPIAH: 23,
    POS_COL_NETTO: 24,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 25,
};

export const HonorHotConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_NIP: 3,
    POS_COL_TARIF: 14,
    POS_COL_JML_USULAN: 15,
    POS_COL_KURANG_BAYAR: 16,
    POS_COL_BRUTO: 17,
    POS_COL_POT_USULAN: 18,
    POS_COL_TAB_PAJAK_PERSEN: 19,
    POS_COL_TAB_PAJAK_RUPIAH: 20,
    POS_COL_POT_PAJAK_PERSEN: 21,
    POS_COL_POT_PAJAK_RUPIAH: 22,
    POS_COL_ZAKAT_RUPIAH: 23,
    POS_COL_NETTO: 24,
    POS_COL_TAB_PAJAK_PERSEN_TEMP: 25,
};

export const HonorEksternalHotConst = {
    POS_COL_TARIF: 7,
    POS_COL_JML_USULAN: 8,
    POS_COL_POT_PAJAK_PERSEN: 9,
    POS_COL_POT_PAJAK_RUPIAH: 10,
    POS_COL_NETTO: 11,
};

export const HotNilaiTutamConst = {
    POS_COL_ID: 0,
    POS_COL_NILAI: 5,
};

export const HotRiwayatUsulanConst = {
    POS_COL_PEGAWAI_ID: 2,
    POS_COL_NIP: 3,
    POS_COL_TARIF: 14,
    POS_COL_JML_USULAN: 15,
    POS_COL_KURANG_BAYAR: 16,
    POS_COL_BRUTO: 17,
    POS_COL_POT_USULAN: 18,
    POS_COL_TAB_PAJAK_PERSEN: 19,
    POS_COL_TAB_PAJAK_RUPIAH: 20,
    POS_COL_POT_PAJAK_PERSEN: 21,
    POS_COL_POT_PAJAK_RUPIAH: 22,
    POS_COL_ZAKAT_RUPIAH: 23,
    POS_COL_NETTO: 24,
};

export const Pesan = {
    OK: {
        STTS: "ok",
        HEADER: "Sukses",
        SUCCESS_ENTRY: "Data berhasil diproses",
    },
    KO: {
        STTS: "ko",
        HEADER: "Perhatian",
        GENERAL_ERROR: "Terjadi kesalahan",
        INVALID_ENTRY: "Isian salah / tidak lengkap",
        INVALID_HOT_DATA: "Data pada table salah",
        NOTFOUND: "Maaf, data kehadiran tidak ditemukan",
        FATAL: "Fatal error occured",
    },
};

export const JenisUsulan = {
    UM: "UM",
    IKW_TUTAM: "IKW_TUTAM",
    IKW_TENDIK: "IKW_TENDIK",
    IKW_DOSEN: "IKW_DOSEN",
    GAJI: "GAJI",
    ITP: "ITP",
    IPP: "IPP",
    IKK: "IKK",
    HONOR: "HONOR",
    HONOR_EKSTERNAL: "HONOR_EKSTERNAL",
};

export const SttsAnggotaKeluarga = {
    PASANGAN: "PASANGAN",
    ANAK: "ANAK",
};

export const Pegawai = {
    MAX_UMUR_ANAK_DIHITUNG_TUNJANGAN: 20,
    MAX_UMUR_ANAK_DIHITUNG_TUNJANGAN_FINAL: 25,
};

export const KeluargaNotif = {
    DEFAULT: "DEFAULT",
    NEXT_BD_21: "NEXT_BD_21",
    IS_FLAG_BAYAR: "IS_FLAG_BAYAR",
};
